export class FbTutorialCompleteHandler {
    public handle(): void {
        if (typeof window.app.fb_tutorial_complete === 'function') {
            window.app.fb_tutorial_complete();
        } else {
            console.warn('No fb_tutorial_complete handler, skipping');
        }
    }
}
